var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6830_82085)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9255 6.63998C22.8461 5.51758 24.5079 5.35268 25.6304 6.27284L25.6304 6.27289C26.7531 7.19323 26.9178 8.85524 25.9977 9.97794L25.6242 10.4336L25.6238 10.4341L17.2345 20.6685C17.2297 20.6743 17.2244 20.6793 17.219 20.6843C17.2149 20.6881 17.2108 20.6919 17.2069 20.6961C17.1917 20.7125 17.1765 20.7287 17.1595 20.7436C17.1438 20.7573 17.1272 20.7693 17.1103 20.7815C17.0932 20.7937 17.0764 20.8057 17.058 20.8164C17.0379 20.828 17.0169 20.8375 16.9956 20.8469C16.9903 20.8493 16.9854 20.8519 16.9805 20.8546C16.9737 20.8583 16.9669 20.8619 16.9594 20.8647L13.2692 22.233C13.1962 22.2602 13.1202 22.2734 13.0447 22.2734C12.8976 22.2734 12.7523 22.2231 12.635 22.127C12.4574 21.9815 12.3705 21.7527 12.4064 21.5259L13.0241 17.6389C13.0252 17.6318 13.0272 17.6251 13.0293 17.6184C13.0309 17.6132 13.0325 17.6081 13.0336 17.6028C13.0387 17.5797 13.0441 17.5567 13.0518 17.5341C13.0583 17.5147 13.0663 17.4963 13.0746 17.4778C13.0834 17.4582 13.0923 17.439 13.1032 17.4201C13.1144 17.4004 13.1273 17.3821 13.1404 17.3639C13.1438 17.3593 13.1467 17.3545 13.1496 17.3498C13.1535 17.3433 13.1575 17.3369 13.1624 17.3308L21.9255 6.63998ZM25.0335 9.11397C25.4621 8.54375 25.3681 7.72869 24.8112 7.27222L24.8111 7.27227C24.2546 6.81589 23.4371 6.8836 22.962 7.41606L25.0335 9.11397ZM15.4542 20.0447L14.1236 18.954L13.8561 20.6372L15.4542 20.0447ZM14.5715 17.6502L16.6446 19.3496L24.2152 10.1138L22.1419 8.41437L14.5715 17.6502ZM15.9726 8.93896H7.10938V27.6066H25.7329V15.4329H24.4329V26.3066H8.40937V10.239H15.9726V8.93896Z",
    fill: "#6621F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6830_82085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.851562 0.955078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.bbb3ffde15ffe4de4101c94f3c8e3fb6.svg";
export { ForwardRef as ReactComponent };